import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetBreadscrumb, setBreadscrumb } from './layoutSlice';

export const useNav = () => {
  const breadscrumb = useSelector((state) => state.layout.breadscrumb);
  const dispatch = useDispatch();

  // 해당 부분은 기존의 전역상태를 완전히 지우고, 새로운 상태로 대체함.
  // reset -> set의 과정과 동일
  const onSetBreadscrumb = useCallback(
    (itemList) => dispatch(setBreadscrumb(itemList)),
    [dispatch]
  );

  // 해당 부분은 기존의 브레드크럼에 새로운 값을 추가함.
  // 이때, 추가하려는 부분이 기존에 이미 존재하는지 검사하는 로직을 거침
  const onAddBreadscrumb = (addItem) => {
    // 기존에 이미 존재하는지 검사
    const isExist = breadscrumb.some(
      (breadcrumbItem) =>
        breadcrumbItem.label === addItem.label &&
        breadcrumbItem.path === addItem.path
    );

    // 존재하면 아무것도 하지 않음
    if (isExist) return;

    // 존재하지 않으면 새로운 값을 추가
    dispatch(setBreadscrumb([...breadscrumb, addItem]));
  };

  const onResetBreadscrumb = () => dispatch(resetBreadscrumb());

  return {
    breadscrumb,
    onSetBreadscrumb,
    onAddBreadscrumb,
    onResetBreadscrumb,
  };
};
